import { DataManager } from "../model/DataManager.js";
import { VOVideo } from "../model/DataStructure.js";
import { SidebarToggle } from "./SidebarToggle.js";
import { VideoPlayer } from "./VideoPlayer.js";
import { VideoText } from "./VideoText.js";

export class VideoView {

    public onSelectVideo = e5.Signal.create<[VOVideo]>();

    public element: HTMLDivElement;

    private _videoPlayer: VideoPlayer;
    private _video: VOVideo = null;
    
    private _text: VideoText;
    private _sidebar: SidebarToggle;

    constructor(private _data: DataManager) {
        this.element = document.createElement("div");
        this.element.classList.add("video-view");
        this.element.innerHTML = `
        <div class="video-view-aspect-ratio">
            <div class="video-view-video">
                <div class="video-view-video-container"></div>
                <div class="video-view-video-overlay"></div>
            </div>
        </div>
        <div class="video-view-text"></div>
        `;
        
        var el = this.element.querySelector(".video-view-text");
        this._text = new VideoText(this._data);
        el.appendChild(this._text.element);
        
        this._sidebar = new SidebarToggle(this._data);
        this.element.appendChild(this._sidebar.element);
        
        this._videoPlayer = new VideoPlayer(this._data);
        this.element.querySelector(".video-view-video-container").appendChild(this._videoPlayer.element);

        if (this._data.config.video_end_bahaviour == "next") {
            this._videoPlayer.onEnded.add((video) => {
                this.requestNext(video);
            });
        }

        this._videoPlayer.onNext.add((video) => {
            this.requestNext(video);
        });

        this._videoPlayer.onPrev.add((video) => {
            this.requestPrev(video);
        });
    }

    private requestNext(video: VOVideo): void {
        var index = this._data.config.videos.indexOf(video);
        if (index == -1) {
            index = 0;
        } else {
            index = e5.Calc.wrap(index + 1, this._data.config.videos.length);
        }
        var next = this._data.config.videos[index];
        if (next) {
            this.onSelectVideo.dispatch(next);
        }
    }

    private requestPrev(video: VOVideo): void {
        var index = this._data.config.videos.indexOf(video);
        if (index == -1) {
            index = this._data.config.videos.length - 1;
        } else {
            index = e5.Calc.wrap(index - 1, this._data.config.videos.length);
        }
        var prev = this._data.config.videos[index];
        if (prev) {
            this.onSelectVideo.dispatch(prev);
        }
    }

    public get video(): VOVideo {
        return this._video;
    }

    public set video(video: VOVideo) {
        this._video = video;
        this._videoPlayer.video = video;
        this._text.video = video;
        this._sidebar.video = video;
    }

    public pause(): void {
        this._videoPlayer.pause();
    }

    public reset():void{
        this._videoPlayer.reset();
        this._sidebar.reset();
    }
}